(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  (() => {
    const initialiseRecipeIndexes = () => {
      document.querySelectorAll('[data-recipe-index]').forEach((root) => {
        if (root.dataset.recipeIndexReady === 'true') return;
        root.dataset.recipeIndexReady = 'true';
        const cards = Array.from(root.querySelectorAll('[data-recipe-card]'));
        const filters = Array.from(root.querySelectorAll('[data-recipe-filter]'));
        const moreButton = root.querySelector('[data-recipe-more]');
        const emptyMessage = root.querySelector('[data-recipe-empty]');
        const status = root.querySelector('[data-recipe-status]');
        const pageSize = Number(root.dataset.pageSize) || 24;
        let activeCategory = 'all';
        let visibleLimit = pageSize;
        const render = () => {
          const matchingCards = cards.filter((card) => activeCategory === 'all' || card.dataset.recipeCategory === activeCategory);
          cards.forEach((card) => { card.hidden = true; });
          matchingCards.slice(0, visibleLimit).forEach((card) => { card.hidden = false; });
          emptyMessage.hidden = matchingCards.length !== 0;
          moreButton.hidden = matchingCards.length <= visibleLimit;
          status.textContent = matchingCards.length === 1
            ? root.dataset.singleLabel
            : root.dataset.countLabel
              .replace('__SHOWN__', Math.min(visibleLimit, matchingCards.length))
              .replace('__TOTAL__', matchingCards.length);
        };
        filters.forEach((button) => {
          button.addEventListener('click', () => {
            activeCategory = button.dataset.recipeFilter;
            visibleLimit = pageSize;
            filters.forEach((filterButton) => {
              const selected = filterButton === button;
              filterButton.classList.toggle('is-active', selected);
              filterButton.setAttribute('aria-pressed', selected ? 'true' : 'false');
            });
            if (document.startViewTransition) document.startViewTransition(render); else render();
          });
        });
        moreButton.addEventListener('click', () => { visibleLimit += pageSize; render(); });
        render();
      });
    };
    document.addEventListener('DOMContentLoaded', initialiseRecipeIndexes);
    document.addEventListener('shopify:section:load', initialiseRecipeIndexes);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-recipe-app"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanText = (value) => {
      const template = document.createElement('template');
      template.innerHTML = String(value || '');
      return template.content.textContent.trim();
    };

    const money = (cents) =>
      new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
      }).format(Number(cents || 0) / 100);

    const numericId = (gid) => String(gid || '').split('/').pop();

    const element = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };

    document.querySelectorAll('[data-recipe-app]').forEach(async (root) => {
      const source = root.querySelector('[data-recipe-json]');
      const content = root.querySelector('[data-recipe-content]');
      let recipe;

      try {
        recipe = JSON.parse(source.textContent.trim());
      } catch (error) {
        content.setAttribute('aria-busy', 'false');
        root.querySelector('[data-status]').textContent = root.dataset.errorMessage;
        return;
      }

      const title = cleanText(recipe.recipe_title);
      const description = cleanText(recipe.recipe_description);
      const image = root.querySelector('[data-recipe-image]');
      const placeholder = root.querySelector('[data-image-placeholder]');

      if (title) root.querySelector('[data-recipe-title]').textContent = title;
      root.querySelector('[data-recipe-description]').textContent = description;
      root.querySelector('[data-prep-time]').textContent = cleanText(recipe.prep_time) || '—';
      root.querySelector('[data-cook-time]').textContent = cleanText(recipe.cook_time) || '—';
      root.querySelector('[data-servings]').textContent = cleanText(recipe.serving_size) || '—';

      if (recipe.recipe_image) {
        image.src = recipe.recipe_image;
        image.alt = cleanText(recipe.recipe_image_alt_text) || title;
        image.hidden = false;
        placeholder.hidden = true;
      }

      const ingredients = Array.isArray(recipe.recipe_ingredients) ? recipe.recipe_ingredients : [];
      const ingredientList = root.querySelector('[data-ingredients]');
      ingredients.forEach((item) => {
        if (item.type === 'heading') {
          ingredientList.append(
            element('li', 'recipe-app__ingredient recipe-app__ingredient--heading', cleanText(item.heading_text))
          );
          return;
        }
        const ingredient = cleanText(item.ingredient);
        if (ingredient) ingredientList.append(element('li', 'recipe-app__ingredient', ingredient));
      });

      const directions = Array.isArray(recipe.recipe_directions) ? recipe.recipe_directions : [];
      const methodList = root.querySelector('[data-method]');
      directions.forEach((item) => {
        if (item.type === 'heading') {
          methodList.append(
            element('li', 'recipe-app__step recipe-app__step--heading', cleanText(item.heading_text))
          );
          return;
        }
        const direction = cleanText(item.direction);
        if (direction) methodList.append(element('li', 'recipe-app__step', direction));
      });

      content.setAttribute('aria-busy', 'false');

      const productReferences = [];
      const seenHandles = new Set();
      const dedicatedProducts = Array.isArray(recipe.recipe_products) ? recipe.recipe_products : [];

      dedicatedProducts.forEach((selected) => {
        if (!selected || !selected.handle || seenHandles.has(selected.handle)) return;
        seenHandles.add(selected.handle);
        productReferences.push(selected);
      });

      ingredients.forEach((item) => {
        const selected = item.selected_product;
        if (!selected || !selected.handle || seenHandles.has(selected.handle)) return;
        seenHandles.add(selected.handle);
        productReferences.push(selected);
      });

      const productsContainer = root.querySelector('[data-products]');
      const emptyMessage = root.querySelector('[data-empty-products]');
      const addButton = root.querySelector('[data-add-selected]');
      const status = root.querySelector('[data-status]');
      const viewBag = root.querySelector('[data-view-bag]');

      if (!productReferences.length) {
        emptyMessage.hidden = false;
        return;
      }

      const updateAddButton = () => {
        addButton.disabled = !productsContainer.querySelector('input[type="checkbox"]:checked');
      };

      const createProductCard = (product, reference) => {
        const card = element('article', 'recipe-app__product');
        const imageWrap = element('div', 'recipe-app__product-image-wrap');
        const productImage = element('img', 'recipe-app__product-image');
        const imageSource =
          product.featured_image ||
          (Array.isArray(product.images) ? product.images[0] : '') ||
          '';

        if (imageSource) {
          productImage.src = imageSource;
          productImage.alt = product.title || reference.title || '';
          productImage.loading = 'lazy';
          imageWrap.append(productImage);
        }

        const cardContent = element('div', 'recipe-app__product-content');
        const choice = element('label', 'recipe-app__product-choice');
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.setAttribute('aria-label', product.title || reference.title || '');

        const choiceText = element('span');
        const productTitle = element(
          'span',
          'recipe-app__product-title',
          product.title || reference.title || ''
        );
        const variants =
          Array.isArray(product.variants) && product.variants.length
            ? product.variants
            : Array.isArray(reference.variants)
              ? reference.variants.map((variant) => ({
                  id: numericId(variant.id),
                  title: variant.title,
                  price: Math.round(Number(variant.price || 0) * 100),
                  available: true
                }))
              : [];
        const initialVariant = variants.find((variant) => variant.available !== false) || variants[0];
        const price = element('span', 'recipe-app__product-price', money(initialVariant?.price));

        choiceText.append(productTitle, price);
        choice.append(checkbox, choiceText);
        cardContent.append(choice);

        if (variants.length > 1) {
          const select = element('select', 'recipe-app__variant');
          select.setAttribute('aria-label', product.title || reference.title || '');
          variants.forEach((variant) => {
            const option = document.createElement('option');
            option.value = variant.id;
            option.textContent = `${variant.title} — ${money(variant.price)}`;
            option.disabled = variant.available === false;
            select.append(option);
          });
          select.addEventListener('change', () => {
            const variant = variants.find((item) => String(item.id) === select.value);
            card.dataset.variantId = select.value;
            price.textContent = money(variant?.price);
          });
          cardContent.append(select);
        }

        card.dataset.variantId = initialVariant?.id || '';

        const quantity = element('div', 'recipe-app__quantity');
        quantity.append(element('span', 'recipe-app__quantity-label', root.dataset.quantityLabel));
        const controls = element('div', 'recipe-app__quantity-controls');
        const decrease = element('button', 'recipe-app__quantity-button', '−');
        decrease.type = 'button';
        decrease.setAttribute(
          'aria-label',
          root.dataset.decreaseLabel.replace('{product}', product.title || reference.title || '')
        );
        const input = element('input', 'recipe-app__quantity-input');
        input.type = 'number';
        input.min = '1';
        input.max = '99';
        input.value = '1';
        input.inputMode = 'numeric';
        input.setAttribute('aria-label', root.dataset.quantityLabel);
        const increase = element('button', 'recipe-app__quantity-button', '+');
        increase.type = 'button';
        increase.setAttribute(
          'aria-label',
          root.dataset.increaseLabel.replace('{product}', product.title || reference.title || '')
        );

        decrease.addEventListener('click', () => {
          input.value = String(Math.max(1, Number(input.value || 1) - 1));
        });
        increase.addEventListener('click', () => {
          input.value = String(Math.min(99, Number(input.value || 1) + 1));
        });
        checkbox.addEventListener('change', updateAddButton);

        controls.append(decrease, input, increase);
        quantity.append(controls);
        cardContent.append(quantity);
        card.append(imageWrap, cardContent);
        return card;
      };

      const productCards = await Promise.all(
        productReferences.map(async (reference) => {
          let product = {
            title: reference.title,
            variants: reference.variants
          };
          try {
            const response = await fetch(`/products/${encodeURIComponent(reference.handle)}.js`);
            if (response.ok) product = await response.json();
          } catch (error) {
            status.textContent = '';
          }
          return createProductCard(product, reference);
        })
      );
      productCards.forEach((card) => productsContainer.append(card));

      addButton.addEventListener('click', async () => {
        const selectedCards = Array.from(
          productsContainer.querySelectorAll('.recipe-app__product')
        ).filter((card) => card.querySelector('input[type="checkbox"]').checked);

        if (!selectedCards.length) {
          status.textContent = root.dataset.selectMessage;
          return;
        }

        const items = selectedCards
          .map((card) => ({
            id: Number(card.dataset.variantId),
            quantity: Number(card.querySelector('.recipe-app__quantity-input').value || 1)
          }))
          .filter((item) => item.id && item.quantity > 0);

        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');
        status.textContent = root.dataset.loadingLabel;
        viewBag.hidden = true;

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('cart');
          status.textContent = root.dataset.addedLabel;
          viewBag.hidden = false;
        } catch (error) {
          status.textContent = root.dataset.errorMessage;
        } finally {
          addButton.removeAttribute('aria-busy');
          updateAddButton();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-recipe-preview"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-recipe-preview]').forEach((root) => {
      const heroImage = root.querySelector('[data-recipe-photo-target]');
      if (heroImage && root.dataset.recipePhoto) {
        heroImage.src = root.dataset.recipePhoto;
        heroImage.srcset = '';
      }

      const cards = Array.from(root.querySelectorAll('[data-product-card]'));

      root.querySelectorAll('[data-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          const card = button.closest('[data-product-card]');
          const input = card.querySelector('[data-product-quantity]');
          const nextValue = Number(input.value || 1) + Number(button.dataset.quantityChange);
          input.value = String(Math.min(20, Math.max(1, nextValue)));
        });
      });

      cards.forEach((card) => {
        const addButton = card.querySelector('[data-add-product]');
        const status = card.querySelector('[data-product-status]');
        const viewBag = card.querySelector('[data-view-bag]');

        if (!addButton) return;

        addButton.addEventListener('click', async () => {
          const item = {
            id: Number(card.dataset.variantId),
            quantity: Number(card.querySelector('[data-product-quantity]').value || 1)
          };

          if (!item.id || item.quantity < 1) return;

          addButton.disabled = true;
          addButton.setAttribute('aria-busy', 'true');
          status.textContent = 'Adding…';
          viewBag.hidden = true;

          try {
            const response = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({ items: [item] })
            });
            const result = await response.json();
            if (!response.ok) {
              throw new Error(result.description || result.message || 'Unable to add this product.');
            }
            status.textContent = 'Added to bag.';
            viewBag.hidden = false;
          } catch (error) {
            status.textContent = error.message || 'Something went wrong. Please try again.';
          } finally {
            addButton.removeAttribute('aria-busy');
            addButton.disabled = false;
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
